import { render, staticRenderFns } from "./SurveyCompleted.vue?vue&type=template&id=7906d150&scoped=true&"
import script from "./SurveyCompleted.vue?vue&type=script&lang=js&"
export * from "./SurveyCompleted.vue?vue&type=script&lang=js&"
import style0 from "./SurveyCompleted.vue?vue&type=style&index=0&id=7906d150&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7906d150",
  null
  
)

export default component.exports